(() => {
  'use strict';
  function apply(root) {
    const cards = [];
    if (root instanceof Element && root.matches('product-card')) cards.push(root);
    root.querySelectorAll?.('product-card').forEach(card => cards.push(card));
    cards.forEach(card => {
      if (!card.querySelector('.price-discount-percentage')) return;
      card.querySelectorAll('.product-badges__badge.color-custom-badge-sale, .promo-guard-badge').forEach(badge => badge.remove());
    });
  }
  function init() {
    apply(document);
    new MutationObserver(mutations => {
      mutations.forEach(mutation => mutation.addedNodes.forEach(node => {
        if (node instanceof Element) apply(node.closest('product-card') || node);
      }));
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
